import React, { useState } from "react";
import {
  Grid,
  Box,
  TextField,
  FormLabel,
  Button,
  InputAdornment,
  IconButton,
} from "../../components/ui";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axios/axiosInstance";
import { Visibility, VisibilityOff } from "../../components/icons";
import { path } from "../../navigation/path";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>(null);
  const [otpSend, setOtpSend] = useState<boolean>(false);
  const [otpVerified, setOtpVerified] = useState<boolean>(false);

  const handleChange = (key: any, value: any) => {
    setFormData({ ...formData, [key]: value });
  };

  const handleSave = async () => {
    try {
      const resp: any = await axiosInstance.post(
        `/api/auth/forgot-password/otp`,
        formData
      );
      if (resp.status === 200) {
        setOtpSend(true);
        toast.success("Otp send successful!");
      }
    } catch (Error: any) {
      console.log(Error);
      toast.error(Error?.response?.data?.body);
    }
  };

  const handleOtpVerify = async () => {
    try {
      const resp: any = await axiosInstance.post(
        `/api/auth/forgot-password/verify`,
        formData
      );
      if (resp.status === 200) {
        navigate(path.UPDATE_PASSWORD, { state: { id: resp?.data?.data?.id } });
        toast.success("Otp Verified successful!");
      }
    } catch (Error: any) {
      console.log(Error);
      toast.error(Error?.response?.data?.body);
    }
  };
  return (
    <div>
      <Box
        width={"100%"}
        height={"98vh"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box width={"30%"}>
          <Grid container spacing={2}>
            <Grid size={12} display={"flex"} justifyContent={"center"}>
              <h2 color="#1F2937">Forgot Password</h2>
            </Grid>
            <Grid size={12}>
              <Box display={"grid"}>
                <FormLabel>Email</FormLabel>
                <TextField
                  disabled={otpSend}
                  variant="outlined"
                  size="small"
                  onChange={(e: any) => handleChange("email", e?.target?.value)}
                />
              </Box>
            </Grid>
            {otpSend && (
              <Grid size={12}>
                <Box display={"grid"}>
                  <FormLabel>Otp</FormLabel>
                  <TextField
                    variant="outlined"
                    size="small"
                    onChange={(e: any) => handleChange("otp", e?.target?.value)}
                  />
                </Box>
              </Grid>
            )}

            {/* <Grid size={12}>
              <Box display={"grid"}>
                <FormLabel>Password</FormLabel>
                <TextField
                  size="small"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  onChange={(e: any) =>
                    handleChange("password", e?.target?.value)
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword} edge="end">
                          {showPassword ? (
                            <VisibilityOff fontSize="small" />
                          ) : (
                            <Visibility fontSize="small" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />{" "}
              </Box>
            </Grid> */}
            <Grid size={12} display={"flex"} justifyContent={"end"}>
              <Button
                variant="contained"
                size="small"
                // color="success"
                sx={{ mx: 1, bgcolor: "#1F2937" }}
                onClick={() => {
                  otpSend ? handleOtpVerify() : handleSave();
                }}
              >
                {otpSend ? "Verify" : "Next"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default ForgotPassword;
